module.exports = __webpack_public_path__ + "static/img/w4.7a961e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/w4.png
// module id = SLhE
// module chunks = 0